import React from 'react';
import { Presentation, GitBranch, Network } from 'lucide-react';
import { AITool } from '../../components/AITool';

export function Poster() {
  return <AITool title="Large Posters" subtitle="High-impact hallway displays" icon={Presentation} layout="infographic-stats" docType="poster" placeholder="Describe your poster, e.g. 'A motivational hand hygiene poster with key stats for staff hallways'" examples={['Hand hygiene compliance impact poster', 'Fall prevention awareness poster', 'Sepsis early recognition poster']} />;
}

export function ProcessGuide() {
  return <AITool title="Step-by-Step Process" subtitle="Sequential workflow guides" icon={GitBranch} layout="infographic-process" docType="process-guide" placeholder="Describe the process, e.g. 'Central line dressing change procedure'" examples={['Central line dressing change', 'Blood transfusion administration', 'Discharge process workflow']} />;
}

export function ClinicalAlgorithm() {
  return <AITool title="Clinical Algorithm" subtitle="YES/NO decision trees & protocols" icon={Network} layout="decision-tree" docType="clinical-algorithm" placeholder="Describe the algorithm, e.g. 'Chest pain triage decision tree'" examples={['Sepsis screening algorithm', 'Fall risk escalation protocol', 'Chest pain triage decision tree']} />;
}
